// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2qn_p","errorLogs":"styles_errorLogs__zgh16"};